import { array, object, string } from 'yup';

import { getMaxLengthErrMsg, mandatoryErrMessage } from '@constants/validationConstants';
import { MAX_50_LENGTH } from '@constants/validationMessages';
import { EAssignOrganisationFields } from './constants';

export const getOrganizationFormSchema = (isJobTitleRequired: boolean) => object({
	[EAssignOrganisationFields.organisation]: object()
		.nullable()
		.default(null)
		.required(mandatoryErrMessage('Organisation')),
	[EAssignOrganisationFields.roles]: array()
		.nullable()
		.default(null)
		.required(mandatoryErrMessage('Roles')),
	[EAssignOrganisationFields.jobTitle]: string()
		.trim()
		.default('')
		.max(MAX_50_LENGTH, getMaxLengthErrMsg('Job Title', MAX_50_LENGTH))
		.when([], {
			is: () => isJobTitleRequired,
			then: (schema) => schema.required(mandatoryErrMessage('Job Title')),
		}),
});
